module.exports = __webpack_public_path__ + "static/img/shengxue.4c0ef031.png";